import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import EtlToooling from '../../../tooling/etlTooling';
import Constants from '../../../definitions/constants';

import GlassPopup from '../common/interface/glassPopup';
import TextBox from '../common/inputs/textBox';
import CheckBox from '../common/inputs/checkBox';
import SelectList from '../common/inputs/selectList';
import ObjectETLDefinition from '../common/inputs/objectETLDefinition';
import ErrorFeedback from '../common/feedback/errorFeedback';
import TagsSelector from '../common/inputs/tagsSelector';
import FormSection from '../common/interface/formSection';

const FormPopup = props => {
  const {
    handleShowPopup,
    handleOnChangeForm,
    handleButton,
    loadingButton,
    fullLoading,
    statusButton,
    formData,
    metricsList,
    errors,
    entityNameSingular,
    handleEditColumnETLTransformationsLink,
    popupState,
    tagsOptions
  } = props;
  var metricsDataSelected = JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metrics_group.metrics");
  let selectedMetricType = (metricsDataSelected && metricsDataSelected.length != 0) ? metricsDataSelected[0].metric_type : null;
  var metricsDataOptionsAux = (metricsDataSelected && metricsDataSelected.length != 0) ? 
    metricsList.filter(item => ((item.dimension_string == metricsDataSelected[0].dimension_string) && (item.metric_type == metricsDataSelected[0].metric_type))) :
    metricsList;

  let etlColumnOptionsArray = EtlToooling.getEtlTransformationsColumnOptions(metricsList, formData, "metrics_group.metrics", "metrics_group.etl_definition")
  let etlFullTransformationsOptions = etlColumnOptionsArray[0] || [];
  let etlTransformationsOptions = etlColumnOptionsArray[1] || [{value: "", label:""}];
  return (
    <GlassPopup
      className="form_popup"
      title={(<FormattedMessage 
         id={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metrics_group.id") ? "common.entity.editEntity" : "common.entity.createEntity"}
         values={{entityNameSingular: entityNameSingular}}
       />)}
      buttonText={(<FormattedMessage 
         id={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metrics_group.id") ? "common.entity.editEntity" : "common.entity.createEntity"}
         values={{entityNameSingular: entityNameSingular}}
       />)}
      type={Constants.interface.popup.types.LATERAL}
      {...props}
    >
      <ErrorFeedback
        status={statusButton}
        fieldErrors={errors}
        localesFieldsPath="metricsGroupAdmin.fields"
      />
      <TextBox 
        styleType={Constants.interface.inputs.styleType.OUTLINED}
        type={Constants.interface.inputs.type.TEXT}
        id="name"
        data-path="metrics_group.name"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metrics_group.name")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="metricsGroupAdmin.fields.name"/>}
        className={("name" in errors) ? "has_error" : null}
      />
      <SelectList        
        values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metrics_group.metrics")}
        onChange={handleOnChangeForm}
        data-path="metrics_group.metrics"
        addSelectLocale={<FormattedMessage id="metricAdmin.addMetricValue"/>}
        labelLocale={<FormattedMessage id="metricAdmin.entityNamePluralFirstUpper"/>}
        noMoreOptionsLocale={intl.formatMessage({id:"metricAdmin.noMoreOptionsMetricsImport"})}
        options={InterfaceTooling.getSelectArrayFromArrayOfObjects(metricsDataOptionsAux, "id", "name", true, intl.formatMessage({id: "metricAdmin.addMetricValue"}))}
        valueAccesor={"id"}
        labelAccesor={"name"}
        className={("metrics" in errors) ? "has_error" : null}
      />
      <FormSection labelLocale={intl.formatMessage({id: "metricsGroupAdmin.formSections.dataImportParameters"})} 
      // toolTipContent="Tooltip de prueba"
      />
      <div className="row_fields pivot_row_fields">
        <CheckBox 
          id="use_pivot_column"
          data-path="metrics_group.use_pivot_column"
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metrics_group.use_pivot_column")}
          onChange={handleOnChangeForm}
          labelLocale={<FormattedMessage id="metricsGroupAdmin.fields.use_pivot_column"/>}
        />
        {JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metrics_group.use_pivot_column") && (
          <TextBox
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            id="pivot_column_name"
            data-path="metrics_group.pivot_column_name"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metrics_group.pivot_column_name")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="metricsGroupAdmin.fields.pivot_column_name"/>}
            className={"pivot_column_name" + (("pivot_column_name" in errors) ? " has_error" : null)}
            toolTipContent={intl.formatMessage({id: "metricsGroupAdmin.fieldsTooltip.pivot_column_name"})}
          />            
        )}
      </div>
      {(selectedMetricType==Constants.metricAdmin.metricType.STANDARD || !selectedMetricType) && (
        <React.Fragment>
          <ObjectETLDefinition 
            id="etl_definition"
            data-path="metrics_group.etl_definition"
            values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metrics_group.etl_definition")}
            columnOptions={etlTransformationsOptions}
            fullColumnOptions={etlFullTransformationsOptions}
            onChange={handleOnChangeForm}
            handleEditColumnETLTransformationsLink={handleEditColumnETLTransformationsLink}
            className={("etl_definition" in errors) ? "has_error" : null}
          />      
          <label className="form_info">
            <FormattedMessage 
              id={"metricsGroupAdmin.fields.etl_def_help"}
            />
          </label>
        </React.Fragment>
      )}
      <CheckBox 
        id="required"
        data-path="metrics_group.required"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metrics_group.required")}
        onChange={handleOnChangeForm}
        labelLocale={(selectedMetricType==Constants.metricAdmin.metricType.VIRTUAL) ? <FormattedMessage id="metricsGroupAdmin.fields.virtual_is_required"/> : 
          (selectedMetricType==Constants.metricAdmin.metricType.DYNAMIC) ? <FormattedMessage id="metricsGroupAdmin.fields.dynamic_is_required"/> :
          <FormattedMessage id="metricsGroupAdmin.fields.is_required"/>}
      />      
      <TextBox 
        styleType={Constants.interface.inputs.styleType.OUTLINED}
        type={Constants.interface.inputs.type.TEXT}
        id="etl_starting_cell"
        data-path="metrics_group.etl_starting_cell"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metrics_group.etl_starting_cell")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="metricsGroupAdmin.fields.etl_starting_cell"/>}
        className={("etl_starting_cell" in errors) ? "has_error" : null}
        toolTipContent={intl.formatMessage({id: "metricsGroupAdmin.fields.etl_starting_cell.tooltip"})}
      />
      <label className="form_info">
        <FormattedMessage id="metricsGroupAdmin.form.etlStartingCellHelp"/>
      </label>
      <label className="form_info">
        <FormattedMessage id="metricsGroupAdmin.form.excelEmptyRownAndColumnsHelp"/>
      </label>
      <TagsSelector
        id="tags"
        values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metrics_group.tags")}
        onClickOption={handleOnChangeForm}
        options={tagsOptions}
        data-path="metrics_group.tags"
      />
    </GlassPopup>
  );
};

export default FormPopup;



// WEBPACK FOOTER //
// ./source/client/components/metricsGroupAdmin/formPopup.jsx